import {Component, Inject, inject} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef
} from "@angular/material/snack-bar";

@Component({
  selector: 'app-status-message',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    MatSnackBarActions,
    MatSnackBarAction,
    MatSnackBarLabel
  ],
  templateUrl: './status-message.component.html',
  styleUrl: './status-message.component.scss'
})
export class StatusMessageComponent {

  private snackBarRef = inject(MatSnackBarRef);

  constructor(@Inject(MAT_SNACK_BAR_DATA) public message: string) {
  }

  close() {
    this.snackBarRef.dismissWithAction();
  }
}
